import './styles.css';
import TabContent from './TabContent';
import TabNavItem from './TabNavItem';

export { TabContent, TabNavItem };
